import KeycloakAuth from './keycloak'
import MockAuth from './mock'
import Auth from './auth'

let instance: Auth | null = null

declare global {
  interface Window {
    ctx: {
      KEYCLOAK_URL?: string
      KEYCLOAK_REALM?: string
      KEYCLOAK_FRONTEND_CLIENT_ID?: string
    }
  }
}

function createAuth(): Auth {
  const ctx = window.ctx

  return ctx?.KEYCLOAK_URL &&
    ctx.KEYCLOAK_REALM &&
    ctx.KEYCLOAK_FRONTEND_CLIENT_ID
    ? new KeycloakAuth(
        ctx.KEYCLOAK_URL,
        ctx.KEYCLOAK_REALM,
        ctx.KEYCLOAK_FRONTEND_CLIENT_ID,
      )
    : new MockAuth()
}

export function getAuth(): Auth {
  if (!instance) {
    instance = createAuth()
  }
  return instance
}
